import { Button } from '@/components/ui/badge';

const FILTERS = {
  age_group: [
    { value: '', label: 'Tous les âges' },
    { value: 'enfants', label: 'Enfants' },
    { value: 'ados', label: 'Ados' },
    { value: 'adultes', label: 'Adultes' }
  ],
  event_type: [
    { value: '', label: 'Tous types' },
    { value: 'jeu', label: 'Jeux de société' },
    { value: 'lecture', label: 'Lecture' },
    { value: 'tcg', label: 'TCG' },
    { value: 'atelier', label: 'Atelier' },
    { value: 'autre', label: 'Autre' }
  ],
  is_free: [
    { value: '', label: 'Tous' },
    { value: 'true', label: 'Gratuit' },
    { value: 'false', label: 'Payant' }
  ]
};

export const FilterBar = ({ filters, onFilterChange }) => {
  const handleFilterClick = (filterType, value) => {
    onFilterChange({
      ...filters,
      [filterType]: filters[filterType] === value ? '' : value
    });
  };

  return (
    <div className="space-y-4" data-testid="filter-bar">
      {/* Age group filters */}
      <div>
        <h4 className="text-sm font-semibold text-[#645E55] mb-2 uppercase tracking-wider">Public</h4>
        <div className="flex flex-wrap gap-2">
          {FILTERS.age_group.map((option) => (
            <button
              key={option.value}
              onClick={() => handleFilterClick('age_group', option.value)}
              className={`filter-chip ${filters.age_group === option.value ? 'active' : ''}`}
              data-testid={`filter-age-${option.value || 'all'}`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Event type filters */}
      <div>
        <h4 className="text-sm font-semibold text-[#645E55] mb-2 uppercase tracking-wider">Type</h4>
        <div className="flex flex-wrap gap-2">
          {FILTERS.event_type.map((option) => (
            <button
              key={option.value}
              onClick={() => handleFilterClick('event_type', option.value)}
              className={`filter-chip ${filters.event_type === option.value ? 'active' : ''}`}
              data-testid={`filter-type-${option.value || 'all'}`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Price filters */}
      <div>
        <h4 className="text-sm font-semibold text-[#645E55] mb-2 uppercase tracking-wider">Prix</h4>
        <div className="flex flex-wrap gap-2">
          {FILTERS.is_free.map((option) => (
            <button
              key={option.value}
              onClick={() => handleFilterClick('is_free', option.value)}
              className={`filter-chip ${filters.is_free === option.value ? 'active' : ''}`}
              data-testid={`filter-price-${option.value || 'all'}`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
